<script>
  import clsx from "clsx";
  let className = null;
  export { className as class };
  export let showLoading = true;
  export let display = "inline-block";
</script>

{#if showLoading}
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" class={clsx(className, display, "h-5 w-5 animate-spin")} aria-hidden="true" focusable="false" role="img">
    <circle opacity="0.25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
    <path opacity="0.75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
  </svg>
{/if}
